module.exports = {"id":"dp1_2l3q4","text":"Evaluating Information","instructions":"What does it mean when an AI system is described as a black box?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":true,"options":[{"id":"dp1_2l3q4-a1","text":"Opaque decision logic","score":3.7},{"id":"dp1_2l3q4-a2","text":"Slow performance","score":1.3},{"id":"dp1_2l3q4-a3","text":"User error","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q4.json
// module id = 952
// module chunks = 41